import $ from 'jquery';
import logger from 'OK/logger';
import navigationLog from 'OK/AjaxNavigationLog';
import screens from 'OK/utils/screens';

var hook_Cfg_GwtExperimentsCfg = document.getElementById('hook_Cfg_GwtExperimentsCfg');
var gwtExperimentsCfg = hook_Cfg_GwtExperimentsCfg ? OK.util.parseJSON(hook_Cfg_GwtExperimentsCfg.innerHTML) : {};
var DATA = "data-";

function updateBlocks(data, status, blockIds, activateAsync) {
    var blocksContent = data.split(OK.navigation.SPLITER);

    blocksContent.forEach(function (blockContent, i) {
        if (blockIds[i]) {
            OK.hookModel.setHookContent(blockIds[i], blockContent, activateAsync);
        }
    });
}

function _ajax(requestData, redirectHandler, retriesElapsed, result) {
    var requestStart = window.performance.now();
    var request = $.ajax(requestData);

    result.xhr = request;

    result.fail(function() {
        request.abort();
    });

    request.done(function(data, textStatus, xhr) {
        navigationLog.log(window.performance.now() - requestStart, requestData.url, xhr.getResponseHeader('X-Render-Time'));
        if (data && xhr.responseText && data.length === 0 && xhr.responseText.length !== 0 && xhr.responseText !== '[]') {
            logger.error("ajax", textStatus);
            logger.clob("ajax", JSON.stringify({"requestData": requestData, "response": xhr.responseText}));
        }

        var token = xhr.getResponseHeader('TKN');
        if (token) {
            OK.tkn.set(token);
        }

        if (OK.state) {
            OK.state.processXhrResponse(xhr);
        }

        var redirectLocation = xhr.getResponseHeader('Redirect-Location');
        if (redirectLocation) {
            redirectHandler(redirectLocation);
            result.reject(xhr, textStatus, 'Redirect');
            return;
        }

        var flags = xhr.getResponseHeader(OK.CLIENT_FLAGS_HEADER);
        if (flags !== null) {
            OK.setClientFlags(flags);
        }

        OK.util.processCssHeaders(xhr).then(function () {
            result.resolve(data, textStatus, xhr);
        });
    });

    request.fail(function(jqXHR, textStatus, errorThrown) {
        if (retriesElapsed > 0) {
            if (textStatus === 'timeout' || !requestData.timeout) {
                _ajax(requestData, redirectHandler, --retriesElapsed, result);
            } else {
                setTimeout(function () {
                    _ajax(requestData, redirectHandler, --retriesElapsed, result);
                }, requestData.timeout);
            }
        } else {
            result.reject(jqXHR, textStatus, errorThrown);
        }
    });

    return result;
}

function getBlockIds(data, status, xhr) {
    var blockIdsHeader = xhr.getResponseHeader(OK.navigation.HEADER);
    if (blockIdsHeader) {
        return blockIdsHeader.split(',');
    }
    return null;
}

function getAttributesFromElement(element, remove) {
    if (typeof element === "string") {
        element = document.getElementById(element);
    }
    var msgs = {};
    for (var i = 0; i < element.attributes.length; i++) {
        var attr = element.attributes[i];
        if (attr.name.indexOf(DATA) == 0) {
            msgs[attr.name.substring(DATA.length)] = attr.value;
        }
    }

    if (remove) {
        element.parentNode.removeChild(element);
    }

    return msgs;
}

function getFormData(form, acceptFn) {
    var data = {};
    var elements = Array.prototype.slice.call(form.elements);
    if (acceptFn) {
        elements = elements.filter(acceptFn);
    }
    elements.forEach(function (element) {
        var elementName = element.name;
        if (elementName) {
            switch (element.type) {
                case 'checkbox':
                    data[elementName] = element.checked ? 'on' : 'off';
                    break;
                case 'radio':
                    if (element.checked) {
                        data[elementName] = element.value;
                    }
                    break;
                default:
                    data[elementName] = element.value;
                    break;
            }
        }
    });
    return data;
}

function parseJson(data) {
    var json = data ? data.replace(/<!--/ig, '').replace(/-->/ig, '') : null;
    return json ? JSON.parse(json) : null;
}

function getBoundingClientRectSafe(node) {
    try {
        return node.getBoundingClientRect();
    }
    catch(e) {
        return { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
    }
}

/**
 * Геометрия текущего фрейма относительно родительского.
 * Используется при вставке в iframe с кастомным ресайзом под размер контента
 * @type { FrameDimensions }
 */
var externalDimensions = null;
function saveParentFrameDimensions(dims) {
    externalDimensions = dims;
}

function getScrollTop() {
    if (externalDimensions != null) {
        return externalDimensions.top >= 0 ? 0 : -externalDimensions.top;
    }

    return window.scrollY;
}

function getWindowInner() {
    if (externalDimensions != null) {
        return {
            width: externalDimensions.windowWidth,
            height: externalDimensions.windowHeight,
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}

function getRealBoundingClientRectSafe(node) {
    var rect = getBoundingClientRectSafe(node);
    var xShift = externalDimensions === null ? 0 : externalDimensions.left;
    var yShift = externalDimensions === null ? 0 : externalDimensions.top;
    return {
        top: rect.top + yShift,
        bottom: rect.bottom + yShift,
        y: rect.y + yShift,

        right: rect.right + xShift,
        left: rect.left + xShift,
        x: rect.x + xShift,

        width: rect.width,
        height: rect.height,

        xShift: xShift,
        yShift: yShift,
    };
}

function unescapeWebUrl(url) {
    return url.replace(/&amp;/g, '&');
}

function ajax(requestData, redirectHandler, retriesLimit) {
    if (arguments.length > 1) {
        if (typeof arguments[1] !== 'function') {
            retriesLimit = redirectHandler;
            redirectHandler = undefined;
        }
    }

    retriesLimit = retriesLimit || 0;
    redirectHandler = redirectHandler || function (redirectLocation) {
            if (OK.navigation.redirect) {
                OK.navigation.redirect(redirectLocation);
            } else {
                document.location.href = decodeURIComponent(redirectLocation);
            }
        };

    var data = requestData.data || {};
    var beforeSend = requestData.beforeSend;
    requestData.type = requestData.type || 'POST';
    if (requestData.type === 'POST' && requestData.contentType
            && requestData.contentType.indexOf('application/json') !== -1) {
        if (typeof data !== 'string') {
            data = JSON.stringify(data);
        }
    } else {
        data['gwt.requested'] = window.pageCtx.gwtHash;
    }
    requestData.data = data;
    requestData.beforeSend = function(jqXHR, settings) {
        jqXHR.setRequestHeader('TKN', OK.tkn.get());
        jqXHR.setRequestHeader('STRD', OK.isStateRedesign());
        jqXHR.setRequestHeader('STRV', OK.getRedesignVersion());
        jqXHR.setRequestHeader(OK.CLIENT_FLAGS_HEADER, OK.getClientFlags());
        var statId = OK.getStatId();
        if (statId) {
            jqXHR.setRequestHeader(OK.STAT_ID_HEADER, statId);
        }

        /*
         * WARN: заголовки стоит добавлять только при AJAX запросах на основной origin
         * Если тут будет CORS запрос, то он может быть заблокирован,
         * если целевой сервер не настроен на приём любых заголовков.
         * Есть мнение, что раз заголовок TKN добавляется к запросам "безусловно",
         * то этот метод никто не использует для CORS.
         * Дайте знать, если это не так.
         */
        screens.apply(jqXHR);
        if (beforeSend) {
            beforeSend.apply(this, arguments);
        }
    };

    return _ajax(requestData, redirectHandler, retriesLimit, $.Deferred());
}

function updateBlockModelCallback(data, status, xhr, activateAsync) {
    var blockIds = getBlockIds(data, status, xhr);
    if (blockIds) {
        updateBlocks(data, status, blockIds, activateAsync);
    }
}

function removeTags(text) {
    return typeof text === 'string' ? text.replace(/<[^>]*>/g, '') : text;
}

function isElementInViewport(el) {
    var rect = getRealBoundingClientRectSafe(el),
        windowInner = getWindowInner();
    if (rect.top < 0 || rect.left < 0 ||
        rect.bottom > windowInner.height ||
        rect.right > windowInner.width) {
        return false;
    }

    var centerX = (rect.right + rect.left) / 2 - rect.xShift,
        centerY = (rect.bottom + rect.top) / 2 - rect.yShift;
    return (el.contains(document.elementFromPoint(centerX, rect.top - rect.yShift)) ||
        el.contains(document.elementFromPoint(rect.right - rect.xShift, centerY)) ||
        el.contains(document.elementFromPoint(centerX, rect.bottom - rect.yShift)) ||
        el.contains(document.elementFromPoint(rect.left - rect.xShift, centerY)));
}

function isElementPartiallyInViewport(el, visiblePartThreshold, disableNullHeight) {
    if (!visiblePartThreshold) {
        return isElementInViewport(el);
    }
    var rect = getRealBoundingClientRectSafe(el),
        windowInner = getWindowInner(),
        visibleHeight = Math.min(rect.bottom, windowInner.height)
            - Math.max(0, rect.top),
        visibleWidth = Math.min(rect.right, windowInner.width)
            - Math.max(0, rect.left),
        elementHeight = el.offsetHeight,
        elementWidth = el.offsetWidth;

    if (!elementHeight && (disableNullHeight !== undefined)) {
        if (disableNullHeight) {
            return false;
        } else {
            // disableNullHeight === false
            return null;
        }
    }
    return elementHeight * visiblePartThreshold <= visibleHeight && elementWidth * visiblePartThreshold <= visibleWidth;
}

function isElementPartiallyInViewportWithOverlapCheck(el, visiblePartThreshold, disableNullHeight) {
    var rect = getRealBoundingClientRectSafe(el);

    if (isElementPartiallyInViewport(el, visiblePartThreshold, disableNullHeight)) {
        var centerX = (rect.right + rect.left) / 2 - rect.xShift,
            centerY = (rect.bottom + rect.top) / 2 - rect.yShift;

        // Провека на перекрытие
        return (el.contains(document.elementFromPoint(centerX, rect.top - rect.yShift)) ||
            el.contains(document.elementFromPoint(rect.right - rect.xShift, centerY)) ||
            el.contains(document.elementFromPoint(centerX, rect.bottom - rect.yShift)) ||
            el.contains(document.elementFromPoint(rect.left - rect.xShift, centerY)));
    }

    return false;
}

function extendDeep(out) {
    out = out || {};

    for (var i = 1; i < arguments.length; i++) {
        var obj = arguments[i];

        if (!obj) {
            continue;
        }

        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                    out[key] = extendDeep(out[key], obj[key]);
                } else {
                    out[key] = obj[key];
                }
            }
        }
    }

    return out;
}

function urlBase64ToUint8Array(base64String) {
    var padding = repeat('=', (4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;

    function repeat(character, times) {
        var res = '';
        while (times-- > 0) {
            res += character;
        }

        return res;
    }
}

function deferred() {
    var resolve, reject;

    return {
        promise: new Promise(function (rslv, rjct) {
            resolve = rslv;
            reject = rjct;
        }),
        resolve,
        reject
    };
}

function positiveId() {
    return OK.util.nextId() || OK.util.nextId();
}

export default { ajax, getBlockIds, updateBlockModelCallback, updateBlocks, gwtExperimentsCfg, removeTags, isElementInViewport, isElementPartiallyInViewport, isElementPartiallyInViewportWithOverlapCheck, extendDeep, urlBase64ToUint8Array, deferred, getAttributesFromElement, getFormData, parseJson, positiveId, saveParentFrameDimensions, getScrollTop, getWindowInner, unescapeWebUrl };

export { ajax, getBlockIds, updateBlockModelCallback, updateBlocks, gwtExperimentsCfg, removeTags, isElementInViewport, isElementPartiallyInViewport, isElementPartiallyInViewportWithOverlapCheck, extendDeep, urlBase64ToUint8Array, deferred, getAttributesFromElement, getFormData, parseJson, positiveId, saveParentFrameDimensions, getScrollTop, getWindowInner, unescapeWebUrl };
